import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Whatsappbutton } from './components/extra';
import { SpeedInsights } from "@vercel/speed-insights/react"


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
    <Whatsappbutton />
    <SpeedInsights />
  </React.StrictMode>
);
